import React from 'react';
import Icon from '../ui/Icon';
import { T } from '../constants/mockData';

const announcements = [
  { id: 1, title: "System Maintenance", text: "Scheduled downtime on Sunday, 2AM-4AM EST for server upgrades.", date: "Oct 24, 2026", type: "warning", icon: "warning", color: "#f59e0b" },
  { id: 2, title: "New Feature Released", text: "You can now export tickets to JSON format. Check it out!", date: "Oct 22, 2026", type: "info", icon: "star", color: "#3b82f6" },
  { id: 3, title: "Security Update", text: "Mandatory password reset will be enforced next week.", date: "Oct 20, 2026", type: "alert", icon: "alert", color: "#ef4444" },
];

export default function AnnouncementsModal({ onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(5,46,22,0.45)", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background: "#FFFFFF", borderRadius: 16, width: 450, maxHeight: "90vh", display: "flex", flexDirection: "column", boxShadow: "0 32px 80px rgba(5,46,22,0.22)" }}>
        <div style={{ padding: "20px 24px 18px", borderBottom: `1px solid ${T.border}`, background: `linear-gradient(135deg, ${T.g50} 0%, #fff 60%)`, borderRadius: "16px 16px 0 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 34, height: 34, borderRadius: 9, background: T.active, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(22,163,74,0.35)" }}>
              <Icon name="note" size={16} color="#fff" />
            </div>
            <div>
              <div style={{ fontSize: 15, fontWeight: 700, color: "#1A202C" }}>Announcements</div>
              <div style={{ fontSize: 11, color: T.muted, marginTop: 1 }}>Important updates and news</div>
            </div>
            <div style={{ flex: 1 }} />
            <button onClick={onClose} style={{ width: 30, height: 30, border: `1px solid ${T.border}`, borderRadius: 7, background: "#FFFFFF", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name="close" size={14} color={T.muted} />
            </button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "20px 24px", display: "flex", flexDirection: "column", gap: 16 }}>
          {announcements.map(ann => (
            <div key={ann.id} style={{ display: "flex", gap: 12, padding: "16px", borderRadius: 12, border: `1px solid ${T.border}`, background: "#FFFFFF" }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: `${ann.color}15`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon name={ann.icon} size={16} color={ann.color} />
              </div>
              <div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 4 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: "#4A5568" }}>{ann.title}</div>
                  <div style={{ fontSize: 11, color: T.muted, whiteSpace: "nowrap", marginLeft: 12 }}>{ann.date}</div>
                </div>
                <div style={{ fontSize: 13, color: "#4b5563", lineHeight: 1.5 }}>{ann.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
